/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { ApiSrc } from "../../../resources/ApiSrc";
import { GetResultObject, PostRequest } from "../../API";

const TYPES = {
    REQUEST_USER_STATISTIC_LIST: "REQUEST_USER_STATISTIC_LIST",  
    REQUEST_USER_STATISTIC_LIST_SUCCESS: "REQUEST_USER_STATISTIC_LIST_SUCCESS",
    REQUEST_USER_STATISTIC_LIST_FAILED: "REQUEST_USER_STATISTIC_LIST_FAILED",        

    REQUEST_WAYBILL_STATISTIC_LIST: "REQUEST_WAYBILL_STATISTIC_LIST",  
    REQUEST_WAYBILL_STATISTIC_LIST_SUCCESS: "REQUEST_WAYBILL_STATISTIC_LIST_SUCCESS",
    REQUEST_WAYBILL_STATISTIC_LIST_FAILED: "REQUEST_WAYBILL_STATISTIC_LIST_FAILED",    

    REQUEST_WALLET_DETAIL_SUCCESS: "REQUEST_WALLET_DETAIL_SUCCESS"
};
  
const getUserStatistic = (body) => {
    return (dispatch) => {
      dispatch({
        type: TYPES.REQUEST_USER_STATISTIC_LIST,
        payload: {},
      });
      PostRequest(
          ApiSrc.GET_USER_STATISTIC, body
      ).then(result => {
        GetResultObject(result, 'data', 200, (data) => {
          dispatch({
            type: TYPES.REQUEST_USER_STATISTIC_LIST_SUCCESS,
            payload: {data: data}});
          })    
       })
    }
}

const getWaybillStatistic = (body) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_WAYBILL_STATISTIC_LIST,
      payload: {},
    });
    PostRequest(
        ApiSrc.GET_WAYBILL_STATISTIC, body
    ).then(result => {
      GetResultObject(result, 'data', 200, (data) => {
        dispatch({
          type: TYPES.REQUEST_WAYBILL_STATISTIC_LIST_SUCCESS,
          payload: {data: data}});
        })    
     })
  }
}

const getWallet = (body, params) => {
  return (dispatch) => {
   
    PostRequest(
        ApiSrc.GET_WALLET_STATISTIC, body, params
    ).then(result => {
      GetResultObject(result, 'data', 200, (data) => {
        dispatch({
          type: TYPES.REQUEST_WALLET_DETAIL_SUCCESS,
          payload: {data: data}});
        })    
     })
  }
}

export default {
    TYPES, getUserStatistic, getWaybillStatistic, getWallet
}